import { useState, useEffect } from "react";

//  Project API
import testimonialsAPI from "../services/testimonialsAPI";

export const useTestimonialsFetch = () => {
    const [state, setState] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const fetchTestimonialsAPI = async page => {
        try {
            setError(false);
            setLoading(true);
            const response = await testimonialsAPI.fetchTestimonials();
            setState(response.data.data.document);
        } catch (error) {
            setError(true);
        }
        setLoading(false);
    };

    useEffect(() => {
        setState([]);
        fetchTestimonialsAPI();
    }, []);

    return {
        state,
        loading,
        error,
    };
};

export default useTestimonialsFetch;
